import { LiveStockInput, LivestockSpecies, RDLivestock } from '@cibo/core'
import * as Yup from 'yup'
import { ITraitFeatureByIdYear } from '../types'
import { findInitialValuesDetail } from '../utils'
import { LivestockCell } from './LivestockCell'
import { LivestockEditor } from './LivestockEditor'
import { LivestockSimpleCell } from './LivestockSimpleCell'

const TRAIT_ID = 'livestock'

export const Livestock: ITraitFeatureByIdYear<RDLivestock> = {
  traitId: TRAIT_ID,
  cellDisplay: LivestockCell,
  SimpleCellView: LivestockSimpleCell,
  editor: LivestockEditor,
  initialValues: props => {
    const detail = findInitialValuesDetail(TRAIT_ID)(props)

    if (!detail?.input) return {}

    if (detail.result || detail.input.daysGrazing) {
      return {
        livestockPresent: 'true',
        ...detail.input,
      }
    } else if (detail?.input.daysGrazing === 0 || detail.result === false) {
      return {
        livestockPresent: 'false',
      }
    }

    return {}
  },
  ns: '@cibo/landmanager/LivestockEditor',
  // @ts-ignore I don't see where we are sending undefined for a Yup.number()
  validationSchema: ({ t }) =>
    Yup.object()
      .shape({
        species: Yup.string<LivestockSpecies>().when('daysGrazing', ([daysGrazing], sch) =>
          daysGrazing > 0
            ? sch.min(1).required(t('required_species_complete'))
            : sch.min(1).optional()
        ),
        headcount: Yup.number().when('daysGrazing', ([daysGrazing], sch) =>
          daysGrazing > 0
            ? sch.min(1).required(t('required_headcount_complete'))
            : sch.min(1).optional()
        ),
        daysGrazing: Yup.number().when('livestockPresent', {
          is: 'true',
          then: (schema: any) =>
            schema
              .min(1)
              .max(365)
              .typeError(t('required', { context: 'daysGrazing' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      })
      .nullable(),

  detailFromEditorValues: (values, requirement) => {
    const input: LiveStockInput = {} as LiveStockInput

    if (values.input?.livestockPresent === 'true') {
      values.input.daysGrazing && (input.daysGrazing = values.input.daysGrazing)
      values.input.species && (input.species = values.input.species)
      values.input.headcount && (input.headcount = values.input.headcount)

      if (Object.values(input).length === 0) {
        return { traitId: TRAIT_ID, year: requirement?.year, result: true }
      }
    }

    return {
      traitId: TRAIT_ID,
      year: requirement?.year,
      input,
    }
  },
}
